/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useContext, useState, useEffect, useMemo } from 'react';
import { useQuery } from 'react-query';
import {
  initialQueryState,
  PaginationState,
  QUERIES,
  WithChildren,
} from '../../../../../_dashboard/helpers';
import { useQueryRequest } from './QueryRequestProvider';
import { getAll } from '../../../../services/common_requests';
import {
  createNewsletterResponseContext,
  NewsletterSubscriber,
  initialNewsletterQueryResponse,
} from './_models';

const QueryNewsletterResponseContext = createNewsletterResponseContext<NewsletterSubscriber>(
  initialNewsletterQueryResponse
);

const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { state } = useQueryRequest();
  const [query, setQuery] = useState<any>(state);
  const updatedQuery = useMemo(() => state, [state]);

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery);
    }
  }, [updatedQuery]);

  const {
    isFetching: isFetchingNewsletters,
    refetch: refetchData,
    data: dataResponse,
  } = useQuery(
    `${QUERIES.NEWSLETTER_LIST}-${JSON.stringify(query)}`,
    () => getAll(query, '/newsletter-emails'),
    { cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false }
  );

  return (
    <QueryNewsletterResponseContext.Provider
      value={{
        isLoading: isFetchingNewsletters,
        refetchData,
        dataResponse,
        query,
      }}
    >
      {children}
    </QueryNewsletterResponseContext.Provider>
  );
};

const useQueryResponse = () => useContext(QueryNewsletterResponseContext);

const useQueryResponseData = () => {
  const { dataResponse } = useQueryResponse();
  if (!dataResponse) {
    return [];
  }
  return dataResponse.data;
};

const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  };

  const { dataResponse } = useQueryResponse();
  if (!dataResponse || !dataResponse.payload || !dataResponse.pagination) {
    return defaultPaginationState;
  }

  return dataResponse.pagination;
};

const useQueryResponseLoading = (): boolean => {
  const { isLoading } = useQueryResponse();
  return isLoading;
};

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
};
